export const HeaderHeight = 64
export const ToolbarHeight = 72
export const PanelWidth = 316

export const CANVAS_WIDTH = window.innerWidth - PanelWidth
export const CANVAS_HEIGHT = window.innerHeight - (HeaderHeight + ToolbarHeight)
export const ZOOM = 4
